module.exports = __webpack_public_path__ + "static/lascaux_devanture-40226fa2d3bc6ae6d61edaf3c8fe1b02.jpg";